import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { AppoloGestionComponent } from './pages/appolo-gestion/appolo-gestion.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'checklist',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/checklist/checklist.component').then((m) => m.ChecklistComponent),
  },
  {
    path: 'incidencia',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/incidencia/incidencia.component').then((m) => m.IncidenciaComponent),
  },
  {
    path: 'parte-seguro',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/parte-seguro/parte-seguro.component').then((m) => m.ParteSeguroComponent),
  },
  {
    path: 'appolo-gestion',
    canActivate: [authGuard],
    component: AppoloGestionComponent,
    data: {
      title: 'Appolo Gestion',
      subtitle: 'Panel integrado',
      url: 'https://appolo.eu/',
    },
  },
  {
    path: 'appolo-traffik',
    canActivate: [authGuard],
    component: AppoloGestionComponent,
    data: {
      title: 'Appolo Traffik',
      subtitle: 'Sistema de identificacion de vehiculos',
      url: 'https://appolo.eu/appolo-traffik-sistema-identificacion-vehiculos',
    },
  },
  {
    path: 'novia',
    canActivate: [authGuard],
    component: AppoloGestionComponent,
    data: {
      title: 'NovIA',
      subtitle: 'Portal corporativo',
      url: 'https://www.labraxsoluciones.com/es/',
    },
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
